import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { getSrc } from 'gatsby-plugin-image'

const SEO = ({
  description,
  lang,
  meta,
  keywords,
  title,
  url,
  image,
  titleExtension = true
}) => {
  const { site, banner } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
        }
      }
      banner: file(relativePath: { eq: "parachute.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 960, height: 540)
        }
      }
    }
  `)

  const titleTemplate = `%s${
    titleExtension ? ` | ${site.siteMetadata.title}` : ''
  }`
  const metaDescription = description || site.siteMetadata.description
  const imageOrLogo = image || site.siteMetadata.siteUrl + getSrc(banner)
  const urlOrHome = url || site.siteMetadata.siteUrl

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      meta={[
        {
          name: 'viewport',
          content: 'width=device-width; initial-scale=1.0; maximum-scale=1.0;'
        },
        {
          name: 'viewport',
          content: 'width=device-width'
        },
        {
          name: 'description',
          content: metaDescription
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:url',
          content: urlOrHome
        },
        {
          property: 'og:description',
          content: metaDescription
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:image',
          content: imageOrLogo
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: title
        },
        {
          name: 'twitter:description',
          content: metaDescription
        },
        {
          name: 'twitter:image',
          content: imageOrLogo
        },
        {
          name: 'twitter:url',
          content: urlOrHome
        }
      ]
        .concat(
          keywords.length > 0
            ? {
                name: 'keywords',
                content: keywords.join(', ')
              }
            : []
        )
        .concat(meta)}
      title={title}
      titleTemplate={titleTemplate}
    />
  )
}

SEO.defaultProps = {
  lang: 'en',
  keywords: [],
  meta: []
}

SEO.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired
}

export default SEO
